import { Text } from '@radix-ui/themes';
import { RADIX } from 'lib_ts/enums/radix-ui';

export const EmptyBodyCell = () => <Text color={RADIX.COLOR.NEUTRAL}>-</Text>;
